import { Injectable } from '@angular/core';
import { EventType } from '../models/ads-events';
import { Part } from '../models/part';
import { ConversionItem } from '../models/conversion-item';
import { Order } from '../models/order';
import { EnhancedConversionData } from '../models/enhanced-conversion-data';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAdsService {
  readonly PURCHASE_EVENT_ID: string = "AW-1046355912/4dZ9CLeDxbwZEMi_-PID"
  readonly ADD_TO_CART_EVENT_ID: string = "AW-1046355912/F873CNm8kb0ZEMi_-PID"
  readonly CURRENCY = 'USD'
  readonly MERCHANT_ID = 9563010

  purchaseEventEmitter(items: ConversionItem[], data: Order) {
    gtag('event', EventType.purchase, {
      'send_to': this.PURCHASE_EVENT_ID,
      'transaction_id': data.id,
      'value': data.subtotal,
      'currency': this.CURRENCY,
      'aw_merchant_id': this.MERCHANT_ID,
      'aw_feed_country': "US",
      'aw_feed_language': "EN",
      'items': items
    })
  };

  addToCartEventEmitter() {
    gtag('event', EventType.conversion, {
      'send_to': this.ADD_TO_CART_EVENT_ID
    })
  }

  PushEnhancedConversionData(ecData: EnhancedConversionData) {
    gtag('set', 'user_data', {
      "email": ecData.email,
      "phone_number": ecData.phone_number,
      "address": {
        "first_name": ecData.address.first_name,
        "last_name": ecData.address.last_name,
        "street": ecData.address.street,
        "city": ecData.address.city,
        "region": ecData.address.region,
        "postal_code": ecData.address.postal_code,
        "country": ecData.address.country
      }
    });
  }

  buildItems(parts: Part[]): ConversionItem[] {
    let items: ConversionItem[] = []
    parts.forEach((p: Part) => {
      items.push(new ConversionItem(p.number.toString(), +p.price, p.count))
    })

    return items
  }
}
